import React, { Component } from 'react';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';
import miscUtils from '../../../utils/miscUtils';

class DocTwitterEntity extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <div>
                    <h3 className="heading-1" id="twitter">Twitter</h3>
                    <div className="description">The extraction of a Twitter mention is based upon the specifications for registering a new 
                        Twitter screen name. A standard Twitter mention starts with an at-sign (@) and is followed by a screen name  
                        consisting of 1-15 word characters (alpha-numeric characters and/or underscores). 
                    </div>
                    <h5 className="heading-3">{"@<screen_name>"}</h5>
                    <div className="example-content">
                        <div className="line">@twitter</div>
                        <div className="line">@twitter_user1</div>
                    </div>
                    <br/>
                    <div className="description">
                        An extracted Twitter mention will be represented by the following attributes:
                    </div>

                    <table className="table-wrapper">
                        <thead className="table-header">
                        <tr>
                            <th>Attribute </th>
                            <th>Meaning </th>
                            <th>Type </th>
                            <th>Constraints</th>
                            <th>Notes </th>
                        </tr>
                        </thead>
                        <tbody className="table-body">
                        <tr>
                            <td className="attribute">twitterScreenName</td>
                            <td className="meaning">Represents the Twitter screen name being mentioned</td>
                            <td className="type">String</td>
                            <td className="constraints">Mandatory</td>
                            <td className="notes">The <i>screen_name</i> parameter for a user lookup according to Twitter's {miscUtils.createExternalLink('https://dev.twitter.com/rest/reference/get/users/lookup')}
                            </td>
                        </tr>
                        <tr>
                            <td className="attribute">twitterUrl</td>
                            <td className="meaning">Represents the Twitter URL for the screen name</td>
                            <td className="type">String</td>
                            <td className="constraints">Mandatory</td>
                            <td className="notes">The Twitter user's account URL at <i>https://twitter.com/${"twitterScreenName"}</i></td>
                        </tr>
                        </tbody>
                    </table>

                    <h5 className="heading-2">Example</h5>
                    <div className="example-content">
                        I will not attend the meeting with <b>@POTUS</b>
                    </div>
                    <HttpRunner example="twitter1" 
                        query="enrich" 
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_TWITTER) : null}/>
                </div>
            </div>
        );
    }
}

export default DocTwitterEntity;